var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _allowedProperties;

var _templateObject = _taggedTemplateLiteralLoose(['\n  ', '\n'], ['\n  ', '\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled, { withTheme } from 'styled-components';
var allowedProperties = (_allowedProperties = {
  "display": true,
  "flexDirection": true,
  "flexFlow": true,
  "flexWrap": true,
  "justifyContent": true,
  "alignItems": true,
  "alignContent": true,
  "order": true,
  "flexGrow": true,
  "flexShrink": true,
  "flexBasis": true,
  "flex": true,
  "alignSelf": true,
  "padding": true,
  "margin": true,
  "maxWidth": true,
  "maxHeight": true,
  "overflow": true,
  "grid": true,
  "gridTemplateColumns": true,
  "gridTemplateRows": true,
  "gridTemplateAreas": true,
  "gridAutoColumns": true,
  "gridAutoRows": true,
  "columnGap": true,
  "rowGap": true,
  "gap": true,
  "gridColumn": true,
  "gridRow": true,
  "gridArea": true,
  "justifyItems": true,
  "justifySelf": true
}, _allowedProperties['alignSelf'] = true, _allowedProperties["placeSelf"] = true, _allowedProperties["placeItems"] = true, _allowedProperties["placeContent"] = true, _allowedProperties["gridColumnStart"] = true, _allowedProperties["gridColumnEnd"] = true, _allowedProperties["gridRowStart"] = true, _allowedProperties["gridRowEnd"] = true, _allowedProperties);
var unitConfig = {
  "rem": 0.25,
  "fr": 1
};

var toKebab = function toKebab(s) {
  return s.replace(/[A-Z]/g, function (l) {
    return '-' + l.toLowerCase();
  });
};

var cleanupProps = function cleanupProps(props) {
  var newProps = {};

  for (var k in props) {
    if (allowedProperties[k]) {
      newProps[toKebab(k)] = props[k];
    }
  }

  return newProps;
};

var isUnitAllowed = function isUnitAllowed(unit) {
  if (typeof unitConfig[unit] === "undefined") return false;
  return true;
};

var splitValueAndUnit = function splitValueAndUnit(size) {
  var m = size.match(/^([0-9\.]+)([a-z]+)?$/);
  if (m === null) return [null, null];
  var value = m[1],
      _m$ = m[2],
      unit = _m$ === undefined ? null : _m$;
  return [value, unit];
};

var isMultiple = function isMultiple(value, unit) {
  var multiple = unitConfig[unit];
  var f = value / multiple;
  return parseInt(f) === f;
};

var constrainSize = function constrainSize(size) {
  size.split(" ").forEach(function (v) {
    var _splitValueAndUnit = splitValueAndUnit(v),
        value = _splitValueAndUnit[0],
        unit = _splitValueAndUnit[1]; //This doesn't seem to be a value and unit pair
    //so nothing to constrain.


    if (value === null || unit === null) return;
    if (!isUnitAllowed(unit)) throw 'Illegal unit: ' + v;

    if (!isMultiple(value, unit)) {
      throw 'Not valid multiple: ' + v;
    }
  });
};

var writeMediaQuery = function writeMediaQuery(k, v) {
  var s = [];

  for (var breakpoint in v) {
    var size = v[breakpoint];
    constrainSize(size);

    if (breakpoint == "default") {
      s.push(k + ': ' + size + ';\n');
    } else {
      s.push('\n@media (max-width: ' + breakpoint + ') {\n  ' + k + ': ' + size + ';\n}\n      ');
    }
  }

  return s.join("");
};

var writeRule = function writeRule(k, v) {
  constrainSize(v);
  return k + ': ' + v + ';\n';
};

var applyProperties = function applyProperties(props) {
  var p = cleanupProps(props);
  var s = [];

  for (var k in p) {
    var v = p[k];

    if (v instanceof Object) {
      s.push(writeMediaQuery(k, v));
    } else {
      s.push(writeRule(k, v));
    }
  }

  return s.join("");
};

var Block = styled.div(_templateObject, function (props) {
  return applyProperties(props);
});

var partial = function partial(props) {
  return function (p) {
    var mergedProps = _extends({}, props, p);

    return React.createElement(Block, mergedProps);
  };
};

export { partial };
export default withTheme(Block);